/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import {
  Box, Button, Grid, makeStyles, MenuItem, TextField, Typography,
  Radio, RadioGroup, FormControlLabel, FormControl, FormLabel,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Phone } from '@material-ui/icons';
import InputWrap from '../atoms/InputWrap';
import {
  ActivityValidation, CityValidation, EmailValidation, NameValidation, PhoneValidation,
} from '../functions/FormValidation';
import Hubspot from '../functions/Hubspot';
import TextFieldStatus from '../atoms/TextFieldStatus';
import MaskedTextField from '../molecules/MaskedTextField';
import AutocompleteCityUF from './AutocompleteCityUF';
import ActivityOptions from '../functions/Options';
import WhatsappIcon from '../atoms/icons/WhatsappIcon';
import { maskBrazilPhone } from '../../helpers/FormantingHelper';

class FormValidator {
  static validateName(name) {
    if (!name) {
      return 'Nome é obrigatório';
    }
    try {
      if (!NameValidation({ firstname: name })) {
        return 'Nome inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'Nome inválido';
    }
  }

  static validateEmail(email) {
    if (!email) {
      return 'E-mail é obrigatório';
    }
    try {
      if (!EmailValidation({ email })) {
        return 'E-mail inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'E-mail inválido';
    }
  }

  static validatePhone(phone) {
    if (!phone) {
      return 'Telefone é obrigatório';
    }
    try {
      if (!PhoneValidation({ phone })) {
        return 'Telefone inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'Telefone inválido';
    }
  }

  static validateCity(city) {
    if (!city) {
      return 'Informe a cidade.';
    }
    try {
      if (!CityValidation({ city })) {
        return 'Informe a cidade.';
      }
      return null;
    } catch (e) {
      return e.message || 'Informe a cidade.';
    }
  }

  static validateState(state) {
    if (!state) {
      return 'Informe a cidade.';
    }
    try {
      if (!CityValidation({ city: state })) {
        return 'Informe a cidade.';
      }
      return null;
    } catch (e) {
      return e.message || 'Informe a cidade.';
    }
  }

  static validateCityName(cityName) {
    if (!cityName) {
      return 'Informe a cidade.';
    }
    try {
      if (!CityValidation({ city: cityName })) {
        return 'Informe a cidade.';
      }
      return null;
    } catch (e) {
      return e.message || 'Informe a cidade.';
    }
  }

  static validateActivity(activity) {
    if (!activity) {
      return 'Informe sua profissão.';
    }
    try {
      if (!ActivityValidation({ activity })) {
        return 'Informe sua profissão.';
      }
      return null;
    } catch (e) {
      return e.message || 'Informe sua profissão.';
    }
  }

  static validateBillingExpectation(billingExpectation) {
    if (!billingExpectation) {
      return 'Informe sua expectativa de faturamento.';
    }
    return null;
  }

  static validateField(fieldName, value) {
    switch (fieldName) {
      case 'firstname':
        return this.validateName(value);
      case 'email':
        return this.validateEmail(value);
      case 'phone':
        return this.validatePhone(value);
      case 'activity':
        return this.validateActivity(value);
      case 'monthly_billing_expectation':
        return this.validateBillingExpectation(value);
      case 'city':
        return this.validateCity(value);
      case 'cityName':
        return this.validateCityName(value);
      case 'state':
        return this.validateState(value);
      default:
        return null;
    }
  }

  static validateAll(data) {
    const errors = {};

    const nameError = this.validateName(data.firstname);
    if (nameError) errors.firstname = nameError;

    const emailError = this.validateEmail(data.email);
    if (emailError) errors.email = emailError;

    const phoneError = this.validatePhone(data.phone);
    if (phoneError) errors.phone = phoneError;

    const cityError = this.validateCity(data.city);
    if (cityError) errors.city = cityError;

    const cityNameError = this.validateCityName(data.cityName);
    if (cityNameError) errors.cityName = cityNameError;

    const stateError = this.validateState(data.state);
    if (stateError) errors.state = stateError;

    const activityError = this.validateActivity(data.activity);
    if (activityError) errors.activity = activityError;

    const billingError = this.validateBillingExpectation(data.monthly_billing_expectation);
    if (billingError) errors.monthly_billing_expectation = billingError;

    return errors;
  }
}

/**
 * @param {string} color
 */
const getButtonColors = (color) => {
  switch (color) {
    case '#0CB49D': {
      return {
        color,
        hover: '#09796A',
        disabled: '#BFD9D5',
      };
    }
    case '#2370FF': {
      return {
        color,
        hover: '#0944B2',
        disabled: '#BBC8E0',
      };
    }
    default: {
      return {
        color,
        hover: '#0673BC',
        disabled: '#BFD4E3',
      };
    }
  }
};

const useStyles = makeStyles(() => ({
  select: {
    '& .MuiSelect-icon': {
      right: '24px',
    },
  },
  radio: {
    color: '#36344B',
    padding: 0,
    '&.Mui-checked': {
      color: '#4FA050',
    },
    '& .MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },
  },
  button: {
    position: 'relative',
    width: '100%',
    background: (props) => props.buttonColor.color,
    '&:hover': {
      background: (props) => props.buttonColor.hover,
    },
    '&:disabled': {
      background: (props) => props.buttonColor.disabled,
    },

    '& .MuiButton-label': {
      color: '#FFFFFF',
    },
  },
}));

/**
 * @param {{
 *  onSuccess?: () => void,
 *  originModal?: (open: boolean) => void,
 *  whatsappOnly?: boolean,
 *  color?: string,
 *  notConvert?: boolean
 * }} props
 */
export default function HownMuchOrOpenCompanyFormDesk({
  onSuccess, color, originModal, whatsappOnly = false, tagWppDesktop, tagPhoneDesktop, notConvert, idWpp, idLigar,
}) {
  const classes = useStyles({ buttonColor: getButtonColors(color) });
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorRoot, setErrorRoot] = useState();

  const changeData = (value, field) => {
    const newData = { ...data, [field]: value };
    setData(newData);

    const error = FormValidator.validateField(field, value);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (error) {
        newErrors[field] = error;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = FormValidator.validateAll(data);
    setErrors(newErrors);
    return newErrors;
  };

  const isFormValid = () => {
    const hasAllRequiredFields = data.firstname && data.email && data.phone
      && data.activity && data.city && data.cityName && data.state
      && data.monthly_billing_expectation;

    const hasNoErrors = Object.keys(errors).length === 0;

    const allFieldsValid = hasAllRequiredFields && hasNoErrors
      && !FormValidator.validateName(data.firstname)
      && !FormValidator.validateEmail(data.email)
      && !FormValidator.validatePhone(data.phone)
      && !FormValidator.validateActivity(data.activity)
      && !FormValidator.validateCity(data.city)
      && !FormValidator.validateCityName(data.cityName)
      && !FormValidator.validateState(data.state)
      && !FormValidator.validateBillingExpectation(data.monthly_billing_expectation);

    return allFieldsValid;
  };

  const handleCityUFChange = (value) => {
    if (value) {
      const updates = {};

      if (value.code) updates.city = value.code;
      if (value.name) updates.cityName = value.name;
      if (value.stateInitial) updates.state = value.stateInitial;

      const newData = { ...data, ...updates };
      setData(newData);

      Object.entries(updates).forEach(([key, val]) => {
        const error = FormValidator.validateField(key, val);
        if (error) {
          setErrors((prev) => ({ ...prev, [key]: error }));
        } else {
          setErrors((prev) => {
            const { [key]: _, ...rest } = prev;
            return rest;
          });
        }
      });
    } else {
      const resetFields = {
        ...data, city: '', cityName: '', state: '',
      };
      setData(resetFields);

      setErrors((prev) => {
        const {
          city, cityName, state, ...rest
        } = prev;
        return rest;
      });
    }
  };

  /**
   * @param {"Via Whatsapp" | "Via Ligação"} customerServiceType
   */
  const handleSubmit = async (customerServiceType) => {
    setErrorRoot(undefined);
    const validationErrors = validateForm();
    // window.open('https://www.google.com', '_blank');
    console.log('Formulário validos');

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setIsLoading(true);

    try {
      await Hubspot.sendToHubspotForm('abrir-empresa', {
        ...data,
        customer_service: customerServiceType,
      });
      setIsLoading(false);

      // Dispara um submit REAL no <form>: as variaveis nativas Form ID/Element
      // do GTM so sao preenchidas por um submit de DOM real, nao por push
      // manual no dataLayer. O onSubmit do form faz preventDefault, entao nao
      // ha navegacao real da pagina.
      const formEl = typeof document !== 'undefined'
        ? document.getElementById(notConvert ? 'contato-wpp' : 'form-open-company')
        : null;
      if (formEl) {
        formEl.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      if (!notConvert) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'form-open-company',
          formId: 'form-open-company',
          // Alimenta o Form ID do GTM neste evento (onde as tags de conversao
          // disparam) por todos os caminhos possiveis: gtm.element (o <form>,
          // pra variavel que le gtm.element.id) e gtm.elementId (a string, pra
          // variavel que le a chave direto do dataLayer).
          'gtm.element': formEl,
          'gtm.elementId': 'form-open-company',
          formName: 'Contato',
          formData: {
            data,
          },
        });
      }
      if (notConvert) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'contato-wpp',
          formId: 'contato-wpp',
          'gtm.element': formEl,
          'gtm.elementId': 'contato-wpp',
          formName: 'Contato',
          formData: {
            data,
          },
        });
      }
      setData({
        firstname: '', email: '', phone: '', city: '', state: '', activity: null, cityName: '', monthly_billing_expectation: '',
      });

      setErrors({});
      if (customerServiceType === 'Via Whatsapp') {
        originModal && originModal(false);
        // window.location.href = `https://api.whatsapp.com/send/?phone=${process.env.GATSBY_WHATSAPP_BUSINESS}&text=Falar%20com%20Especialista&type=phone_number&app_absent=0`;
        window.open(`https://api.whatsapp.com/send/?phone=${process.env.GATSBY_WHATSAPP_BUSINESS}&text=Falar%20com%20Especialista&type=phone_number&app_absent=0`, '_blank');
        onSuccess();
      } else {
        onSuccess();
      }
    } catch (error) {
      setErrorRoot('Desculpe, ocorreu um erro. Tente novamente mais tarde! ;-;');
    } finally {
      setIsLoading(false);
    }
  };

  // Botão desabilitado quando: está carregando OU o formulário não está válido
  const disabled = isLoading || !isFormValid();

  return (
    <form
      id={notConvert ? 'contato-wpp' : 'form-open-company'}
      // Os botoes NAO disparam submit de proposito (type=button + onClick):
      // o coletor de forms do HubSpot captura o evento de submit, e este form
      // nao deve mais ser coletado (o lead vai via API pro form nativo).
      // Os eventos do Google/GTM continuam vindo dos pushes de dataLayer.
      onSubmit={(e) => e.preventDefault()}
    >
      <Typography style={{ paddingBottom: '16px' }}>
        Dados pessoais
      </Typography>
      <Box style={{ paddingBottom: '36px' }}>
        <InputWrap>
          <TextField
            label="Nome"
            name="firstname"
            value={data.firstname}
            onChange={(e) => changeData(e.target.value, 'firstname')}
            error={Boolean(errors.firstname)}
            helperText={errors.firstname}
            placeholder="Nome completo"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.firstname)}
                  value={data.firstname && !errors.firstname}
                />
              ),
            }}
          />

          <TextField
            label="E-mail"
            name="email"
            type="email"
            value={data.email}
            onChange={(e) => changeData(e.target.value, 'email')}
            error={Boolean(errors.email)}
            helperText={errors.email}
            disabled={isLoading}
            placeholder="seu_email@mail.com.br"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.email)}
                  value={data.email && !errors.email}
                />
              ),
            }}
          />

          <TextField
            onChange={(e) => {
              changeData(maskBrazilPhone(e.target.value), 'phone');
            }}
            value={data.phone}
            onClick={() => { changeData('+55 (', 'phone'); }}
            mask="+55 (99) 99999-9999"
            label="Telefone"
            type="tel"
            textFieldProps={{
              label: 'Telefone',
              name: 'phone',
              type: 'tel',
              value: data.phone,
              floating: true,
              error: Boolean(errors.phone),
              helperText: errors.phone,
            }}
            placeholder="+55 (DDD) 00000-0000"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              disabled: isLoading,
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.phone)}
                  value={data.phone && !errors.phone}
                />
              ),
            }}
          />

          <AutocompleteCityUF
            onChange={(value) => handleCityUFChange(value)}
            value={{
              stateInitial: data.state,
              code: data.city,
              name: data.cityName,
            }}
            placeholder="Ex: São Paulo"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.city)}
                  value={data.city && !errors.city}
                />
              ),
            }}
            error={Boolean(errors.city)}
            helperText={errors.city}
            disabled={isLoading}
          />
          <TextField
            label="Qual será a atividade?"
            name="activity"
            value={data.activity}
            onChange={(e) => changeData(e.target.value, 'activity')}
            disabled={isLoading}
            className={classes.select}
            placeholder="Ex: programador, designer"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            error={Boolean(errors.activity)}
            helperText={errors.activity}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.activity)}
                  value={data.activity && !errors.activity}
                />
              ),
            }}
            select
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected) => {
                if (!selected) {
                  return (
                    <span style={{ color: 'rgba(0, 0, 0, 0.3)' }}>
                      Ex: programador, designer
                    </span>
                  );
                }
                return data.activity;
              },
            }}
          >
            {ActivityOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <FormControl
            component="fieldset"
            error={Boolean(errors.monthly_billing_expectation)}
            disabled={isLoading}
            style={{ width: '238px', height: '115px' }}
          >
            <FormLabel
              component="legend"
              style={{
                fontSize: '0.75rem',
                fontWeight: 400,
                transform: 'none',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
            >
              Qual a sua expectativa de faturamento mensal?
            </FormLabel>
            <RadioGroup
              row
              name="monthly_billing_expectation"
              value={data.monthly_billing_expectation || ''}
              onChange={(e) => changeData(e.target.value, 'monthly_billing_expectation')}
              style={{ gap: '2px', marginTop: '8px' }}
            >
              <FormControlLabel
                value="Até R$ 6 mil"
                style={{ marginLeft: 0 }}
                control={<Radio className={classes.radio} style={{ marginRight: '8px' }} />}
                label={<Typography style={{ fontSize: '0.75rem', color: '#383743' }}>Até R$ 6 mil</Typography>}
              />
              <FormControlLabel
                value="Acima de R$ 6 mil"
                style={{ marginLeft: 0 }}
                control={<Radio className={classes.radio} style={{ marginRight: '8px' }} />}
                label={<Typography style={{ fontSize: '0.75rem', color: '#383743' }}>Acima de R$ 6 mil</Typography>}
              />
            </RadioGroup>
            {errors.monthly_billing_expectation && (
              <Typography variant="caption" style={{ color: '#f44336' }}>
                {errors.monthly_billing_expectation}
              </Typography>
            )}
          </FormControl>
        </InputWrap>
      </Box>

      {errorRoot && <Typography component="span" style={{ color: '#D12E26' }}>{errorRoot}</Typography>}

      {!whatsappOnly && (
        <Typography style={{ marginBottom: '10px', color: '#383743' }}>
          Como você prefere ser atendido?
        </Typography>
      )}

      <Grid container spacing={4}>
        <Grid item xs={12} sm={whatsappOnly ? 12 : 6} style={{ display: whatsappOnly && 'flex', justifyContent: whatsappOnly && 'center' }}>
          <Button
            id={idWpp}
            className={classes.button}
            style={{ width: whatsappOnly && '238px' }}
            disabled={disabled}
            type="button"
            name="wpp"
            onClick={() => {
              tagWppDesktop();
              handleSubmit('Via Whatsapp');
            }}
          >
            <WhatsappIcon
              height="20px"
              width="20px"
              style={{
                position: 'absolute', top: '50%', translate: '0 -40%', width: '20px', left: '18px',
              }}
            />
            VIA WHATSAPP
          </Button>
        </Grid>
        {!whatsappOnly && (
          <Grid item xs={12} sm={6}>
            <Button
              id={idLigar}
              className={classes.button}
              disabled={disabled}
              type="button"
              name="tel"
              onClick={() => {
                tagPhoneDesktop();
                handleSubmit('Via Ligação');
              }}
            >
              <Phone style={{ position: 'absolute', left: '18px' }} />
              VIA LIGAÇÃO
            </Button>
          </Grid>
        )}
      </Grid>
    </form>
  );
}
HownMuchOrOpenCompanyFormDesk.defaultProps = {
  onSuccess: () => { },
  originModal: undefined,
  whatsappOnly: false,
  color: '#0093F5',
  tagWppDesktop: () => { },
  tagPhoneDesktop: () => { },
  idWpp: undefined,
  idLigar: undefined,
};
HownMuchOrOpenCompanyFormDesk.propTypes = {
  onSuccess: PropTypes.func,
  originModal: PropTypes.func,
  whatsappOnly: PropTypes.bool,
  color: PropTypes.string,
  tagWppDesktop: PropTypes.func,
  tagPhoneDesktop: PropTypes.func,
  idWpp: PropTypes.string,
  idLigar: PropTypes.string,
};
